import { useEffect } from 'react';

import { IS_PRERENDER } from '@sorare/core/src/config';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

const loadScript = async (src: string, scriptId: string, id?: string) => {
  return new Promise((resolve, reject) => {
    if (document.getElementById(scriptId)) {
      resolve(undefined);
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = src;
    if (id) script.setAttribute('data-id', id);
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
};

declare global {
  interface Window {
    zESettings: any;
    zE: any;
    quidget: {
      init: () => void;
      destroy: () => void;
      openChat: () => void;
    };
  }
}

export const openWidget = () => {
  if (window.zE) {
    window.zE('webWidget', 'show');
    window.zE('webWidget', 'open');
    window.zE('webWidget:on', 'close', () => window.zE('webWidget', 'hide'));
  }
};

const ZDForm = () => {
  const { currentUser } = useCurrentUserContext();

  if (window.zE) window.zE('webWidget', 'hide');

  useEffect(() => {
    if (IS_PRERENDER) return () => {};

    loadScript(
      'https://static.zdassets.com/ekr/snippet.js?key=5f9868fc-4b4d-4ddf-980f-a12935a05f96',
      'ze-snippet'
    );

    return () => {};
  }, []);

  // oxlint-disable-next-line react/immutability
  window.zESettings = {
    webWidget: {
      contactForm: {
        fields: [
          { id: 'email', prefill: { '*': currentUser?.email } },
          { id: '360023889697', prefill: { '*': currentUser?.nickname } },
        ],
        ticketForms: [{ id: '22003730653597' }],
      },
    },
  };

  return null;
};

export const Form = () => {
  useEffect(() => {
    if (IS_PRERENDER) return () => {};

    if (window.quidget?.init) {
      window.quidget.init();
    } else {
      loadScript(
        'https://quidget.ai/webchat/quidget.loader.js',
        'quidget-loader',
        'c8aa4d39-a732-4196-bb29-8bcd29f0c9fb'
      );
    }

    return () => {
      if (window.quidget?.destroy) {
        window.quidget.destroy();
      }
    };
  }, []);

  return <ZDForm />;
};
